import { ApiClient } from '../apiClient';
import {
  ReferralCode,
  ReferralCodes,
  ReferralProgram,
  ReferralReward,
} from '../../types/referral';
import { PaginationDto } from '../../types/pagination';

export class ReferralService {
  constructor(private apiClient: ApiClient) {}

  async getProgram(): Promise<ReferralProgram> {
    return this.apiClient.get<ReferralProgram>('/referrals/program');
  }

  // Ensures the user's default codes (username + random) exist and returns
  // them grouped by type. Lossy for multiple random codes (returns the first
  // only) - call getAllCodes for the complete list.
  async getCodes(): Promise<ReferralCodes> {
    return this.apiClient.get<ReferralCodes>('/referrals/codes');
  }

  // Full flat list of the user's active codes (every random/custom row).
  async getAllCodes(): Promise<ReferralCode[]> {
    return this.apiClient.get<ReferralCode[]>('/referrals');
  }

  // Creates an additional (auto-generated) referral code. The string is
  // server-generated.
  async createCode(): Promise<unknown> {
    return this.apiClient.post<unknown>('/referrals', {});
  }

  async deleteCode(id: string): Promise<unknown> {
    return this.apiClient.delete<unknown>(`/referrals/${id}`);
  }

  // PENDING referral rewards owed to this referrer. CREDITED ones ride the
  // balance ledger via the REFERRAL type, so we don't double-surface them.
  async getMyPendingRewards(
    page = 0,
    limit = 25,
  ): Promise<PaginationDto<ReferralReward>> {
    return this.apiClient.post<PaginationDto<ReferralReward>>(
      '/user/referral-rewards/pending',
      {
        page,
        limit,
        sortBy: { maturityDate: 1 },
      },
    );
  }

  async getMyPendingRewardTotalCents(): Promise<{ totalCents: number }> {
    return this.apiClient.get<{ totalCents: number }>(
      '/user/referral-rewards/pending/total',
    );
  }
}
